import type { Params } from '@angular/router';
import type { RouterReducerState } from '@ngrx/router-store';
import type { RouterState } from './router.type';

import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ROUTER_FEATURE_KEY } from './feature-key';

const routerState = createFeatureSelector<RouterReducerState<RouterState>>(ROUTER_FEATURE_KEY);

export const selectRouterState = createSelector(
    routerState,
    (router: RouterReducerState<RouterState>): RouterState => router?.state
);

export const selectRouterParams = createSelector(selectRouterState, (state: RouterState): Params => state?.params);

export const selectRouterUrl = createSelector(selectRouterState, (router: RouterState): string => router?.url);

export const selectRouterQueryParams = createSelector(
    selectRouterState,
    (state: RouterState): Params => state?.queryParams
);
